import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Redirect, Link } from "react-router-dom";
import InviteCodeList from "./InviteCodeList";

/*
  @author Created by fireator-cli
  @description InviteCodes Component
  Generated at Wed, 25 Nov 2020 14:39:49 GMT
*/

function InviteCodes(props) {
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const renderInviteCodes = () => {
    const { inviteCodes } = props;
    if (inviteCodes) {
      return (
        <div className="row">
          <InviteCodeList inviteCodes={inviteCodes} />
        </div>
      );
    }
  };

  return (
    <div className="dashboard container">
      {renderInviteCodes()}
      <Link
        className="btn-floating btn-large fixed-action-btn green right"
        to="newInviteCode"
      >
        <i className="material-icons">add</i>
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    inviteCodes: state.firestore.ordered.inviteCodes,
    auth: state.firebase.auth,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "inviteCodes",
      orderBy: ["code", "asc"],
    },
  ])
)(InviteCodes);
